import { WEBHOOK_EVENT_DETAILS, WEBHOOK_EVENT_VALUES } from "@dune/types";
import z from "zod";

export const webhookFormSchema = z.object({
	name: z
		.string()
		.min(1, "Le nom est requis")
		.max(120, "Le nom doit contenir au plus 120 caracteres"),
	url: z.url("L'URL doit etre valide"),
	description: z
		.string()
		.max(500, "La description doit contenir au plus 500 caracteres")
		.optional()
		.or(z.literal("")),
	isActive: z.boolean(),
	events: z
		.array(z.enum(WEBHOOK_EVENT_VALUES))
		.min(1, "Selectionnez au moins un évènement"),
});

export type WebhookFormValues = z.infer<typeof webhookFormSchema>;

export const defaultFormValues: WebhookFormValues = {
	name: "",
	url: "",
	description: "",
	isActive: true,
	events: [WEBHOOK_EVENT_VALUES[0]],
};

export const eventOptions = WEBHOOK_EVENT_VALUES.map((event) => ({
	value: event,
	label: WEBHOOK_EVENT_DETAILS[event].label,
	description: WEBHOOK_EVENT_DETAILS[event].description,
}));

export const normalizePayload = (values: WebhookFormValues) => ({
	name: values.name.trim(),
	url: values.url.trim(),
	description:
		values.description && values.description.trim().length > 0
			? values.description.trim()
			: undefined,
	isActive: values.isActive,
	events: values.events,
});
